<script setup lang="ts">
import HamburgerIcon from '@/assets/SideMenu/HamburgerIcon.svg'
import logoLight from '/logo-light.svg'

import DashboardIcon from '@/assets/SideMenu/DashboardIcon.svg'
import CalendarIcon from '@/assets/SideMenu/CalendarIcon.svg'
import NetworkIcon from '@/assets/SideMenu/NetworkIcon.svg'
// import ServiceIcon from '@/assets/SideMenu/ServiceIcon.svg'
// import EfficiencyIcon from '@/assets/SideMenu/EfficiencyIcon.svg'
import UsersIcon from '@/assets/SideMenu/UsersIcon.svg'
import InviteIcon from '@/assets/SideMenu/InviteIcon.svg'
import SideMenuButton from './SideMenuButton.vue'
import { useMethodResourceTanstack } from '@/composables/useWebsocketValues'
import { computed } from 'vue'

const sidebarOpen = defineModel<boolean>('sidebarOpen', { default: false })

const organizationType = useMethodResourceTanstack(
  { method: 'organizationType' },
  {
    refetchInterval: 3600 * 1000, //refetch every hour, since organization type is unlikely to change frequently
    staleTime: 3600 * 1000,
  },
)
// const isManufacturer = computed(() => organizationType.data.value === 'manufacturer')
// const isDistributor = computed(() => organizationType.data.value === 'manufacturer' || organizationType.data.value === 'distributor')
// const isEndDistributor = computed(
//   () =>
//     organizationType.data.value === 'manufacturer' ||
//     organizationType.data.value === 'distributor' ||
//     organizationType.data.value === 'endDistributor',
// )
const isPlainEndClient = computed(() => organizationType.data.value === 'end')
</script>

<template>
  <nav class="side-menu" :class="{ expanded: sidebarOpen }">
    <div class="hamburger-container">
      <button class="hamburger-button" @click="sidebarOpen = !sidebarOpen">
        <HamburgerIcon />
      </button>
      <div class="logo-container">
        <img :src="logoLight" alt="Logo" />
      </div>
    </div>
    <div class="menu-items">
      <SideMenuButton v-if="!isPlainEndClient" :to="{ name: 'dashboard' }">
        <template #icon>
          <DashboardIcon />
        </template>
        {{ $t('sideMenu.manufacturerDashboard') }}
      </SideMenuButton>

      <SideMenuButton :to="{ name: 'clientDashboard' }">
        <template #icon>
          <DashboardIcon />
        </template>
        {{ $t('sideMenu.clientDashboard') }}
      </SideMenuButton>

      <!-- <SideMenuButton :to="{ name: 'networkDashboard' }">
        <template #icon>
          <DashboardIcon />
        </template>
        {{ $t('sideMenu.dashboard') }}
      </SideMenuButton> -->

      <SideMenuButton :to="{ name: 'devices' }">
        <template #icon>
          <NetworkIcon />
        </template>
        {{ $t('sideMenu.devices') }}
      </SideMenuButton>

      <SideMenuButton v-if="!isPlainEndClient" :to="{ name: 'organizations' }">
        <template #icon>
          <CalendarIcon />
        </template>
        {{ $t('sideMenu.organizations') }}
      </SideMenuButton>

      <SideMenuButton :to="{ name: 'users' }">
        <template #icon>
          <UsersIcon />
        </template>
        {{ $t('sideMenu.users') }}
      </SideMenuButton>

      <SideMenuButton :to="{ name: 'inviteToOrganization' }">
        <template #icon>
          <InviteIcon />
        </template>
        {{ $t('sideMenu.invitesToOrganization') }}
      </SideMenuButton>

      <SideMenuButton v-if="!isPlainEndClient" :to="{ name: 'inviteToMachines' }">
        <template #icon>
          <InviteIcon />
        </template>
        {{ $t('sideMenu.invitesToMachines') }}
      </SideMenuButton>

      <!-- <SideMenuButton :to="{ name: 'service' }">
        <template #icon>
          <ServiceIcon />
        </template>
        {{ $t('sideMenu.service') }}
      </SideMenuButton> -->

      <!-- <SideMenuButton :to="{ name: 'efficiency' }">
        <template #icon>
          <EfficiencyIcon />
        </template>
        {{ $t('sideMenu.efficiency') }}
      </SideMenuButton> -->
    </div>
  </nav>
</template>

<style lang="scss" scoped>
.side-menu {
  position: fixed;
  width: var(--ullib-size-sidebar-width-collapsed);
  max-width: var(--ullib-size-sidebar-width-collapsed);
  height: 100%;
  background-color: var(--ullib-color-primary);
  z-index: 10;
  overflow: hidden;

  transition:
    width 0.3s ease-in-out,
    max-width 0.3s ease-in-out;

  &.expanded {
    width: var(--ullib-size-sidebar-width-expanded);
    max-width: var(--ullib-size-sidebar-width-expanded);
  }
}

.hamburger-container {
  height: var(--ullib-size-header-height);
  display: flex;
  align-items: center;
  padding: 0 13px;
  background-color: var(--ullib-color-primary);
}

.hamburger-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  background-color: transparent;
  border: none;
  transition: background-color 0.1s ease-in;
  &:hover {
    background-color: var(--ullib-color-hamburger-hover);
  }
}

.logo-container {
  img {
    min-height: 24px;
    height: 24px;
  }
  margin-left: 32px;
  flex-shrink: 0;
}

.menu-items {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
</style>
